import {ChevronRight} from '@mui/icons-material';
import {Box, Typography} from '@mui/material';
import ArrTooltip from '../../../components/common/arr-tooltip/ArrTooltip';

const TooltipDemo: React.FC = () => {
  return (
    <Box className="demo-page modal-demo">
      <h1>Tooltips</h1>
      <Box p={4} display="flex" flexDirection="column" gap={4}>
        {/* Hover trigger */}
        <Box>
          <ArrTooltip content="This tooltip shows on hover">
            <Typography
              variant="body1"
              sx={{cursor: 'default', display: 'inline-flex'}}
            >
              Hover over me
            </Typography>
          </ArrTooltip>
        </Box>

        {/* Click trigger */}
        <Box>
          <ArrTooltip content="This tooltip toggles on click" trigger="click">
            <Typography
              variant="body1"
              sx={{cursor: 'pointer', display: 'inline-flex'}}
            >
              Click me
            </Typography>
          </ArrTooltip>
        </Box>

        {/* Placement right */}
        <Box>
          <ArrTooltip content="Tooltip on the right" placement="right">
            <Typography
              variant="body1"
              sx={{cursor: 'default', display: 'inline-flex'}}
            >
              Hover for right placement
            </Typography>
          </ArrTooltip>
        </Box>

        {/* Info icon sizes and offset */}
        <Box>
          <ArrTooltip content="Small info icon" size="small" offset={8} />
        </Box>
        <Box>
          <ArrTooltip content="Large info icon" size="large" />
        </Box>

        {/* Navigation */}
        <Box>
          <ArrTooltip content="View PAGE" trigger="hover">
            <ChevronRight fontSize="small" />
          </ArrTooltip>
        </Box>

        {/* Show tooltip on Truncated data */}
        <Box>
          <h3>Truncated Long Data</h3>
          <ArrTooltip
            content="Lorem ipsum dolor sit amet, consectetur"
            isTruncated
            showOnTruncate
            trigger="hover"
            placement="top"
          >
            Lorem ipsum d...
          </ArrTooltip>
        </Box>
        <Box>
          <h3>Not Truncated Data</h3>
          <ArrTooltip
            content="Lorem ipsum"
            isTruncated={false}
            showOnTruncate
            trigger="hover"
          >
            Lorem ipsum
          </ArrTooltip>
        </Box>
      </Box>
    </Box>
  );
};

export default TooltipDemo;
